import Text from '../Text';
import Game from '../../Game';
import AnimationComponent from '../../Component/Animation';
import Point from '../../Utility/Point';
import GameObject from '../../GameObject/GameObject';
import Sprite from '../Sprite';

export default class CoinCardEffect extends Text {
    public onCreate(params: any): void {
        super.onCreate({
            style: Game.style.getStyle('score.text'),
            anchor: new Point(1, 0.5),
            ...params,
        });

        const coin: Sprite = GameObject.Instantiate(Sprite, {
            name: 'card_coin_reward_icon',
            anchor: new Point(0, 0.5),
            texture: 'level_coin_medium',
            scale: new Point(0.85, 0.85),
            x: -2,
        });
        this.addChild(coin);

        this.addComponent(AnimationComponent, {
            playOnStart: true,
            clipName: 'ScoreTextPopIn',
            ...params,
        });
    }
}
